import type { BoxProps } from '@mantine/core';
import { Box } from '@mantine/core';
import { useListBoxStyles } from './ListBox.styles';

interface ListBoxDividerProps extends BoxProps {}

export function ListBoxDivider({
	className,
	...boxProps
}: ListBoxDividerProps) {
	const { classes, cx } = useListBoxStyles();

	return <Box {...boxProps} className={cx(classes.divider, className)} />;
}
